import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupUpdateInfoContentProps {
  message: Msg;
}

export const MsgGroupUpdateInfoContent = memo(function MsgGroupUpdateInfoContent({
  message,
}: MsgGroupUpdateInfoContentProps) {
  const { operator_user_id, new_owner_id } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);
  const { user: newOwnerUser } = useUserInfo(new_owner_id);

  return (
    <MyTrans
      i18nKey="chat.groupMessageOwnerChangedText"
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        newOwner: <MsgUserText userName={newOwnerUser?.name || ''} userId={new_owner_id} />,
      }}
      values={{
        value: `'${newOwnerUser?.name || ''}'`,
      }}
    ></MyTrans>
  );
});
